import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAuth0 } from '@auth0/auth0-react';
import { useCurrentUser } from '../../hooks/useCurrentUser';

const SentryUser = () => {
  const { isAuthenticated } = useAuth0();

  const user = useCurrentUser();

  useEffect(() => {
    if (!isAuthenticated) {
      Sentry?.setUser(null);
      return;
    }
  }, [isAuthenticated]);

  useEffect(() => {
    Sentry?.setUser({
      id: user?.id || '',
      email: user?.contactEmail || '',
    });
  }, [user]);

  return null;
};

export default SentryUser;
